import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 12"
}, n = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.262.965c.25.238.26.634.02.883l-8.75 9.167a.625.625 0 0 1-.893.01L.722 8.11a.625.625 0 1 1 .884-.884L4.07 9.689 12.38.985a.625.625 0 0 1 .883-.02",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function c(d, s) {
  return e(), o("svg", l, [...r]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
